import { Link } from '@tanstack/react-router';
import { CircleArrowLeft } from 'lucide-react';

import { StudentChargeHistory } from '~features/payment/ui/student-charge-history';

export const StudentChargeHistoryPage = () => {
  return (
    <div className=''>
      <Link
        to='/payment/class-charge-history'
        className='flex items-center gap-2'
      >
        <CircleArrowLeft className='size-6' />
        <h2 className='text-2xl font-semibold'>Student Charge History</h2>
      </Link>
      <div className='mt-8 border-t'>
        <div className='mt-6'>
          <StudentChargeHistory />
        </div>
      </div>
    </div>
  );
};
